import React from 'react';
import Input from '../../../components/ui/Input';

const SearchBar = ({ value, onChange, placeholder = "Search files..." }) => {
  return (
    <div className="w-full max-w-md">
      <Input
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e?.target?.value)}
        className="w-full"
      />
    </div>
  );
};

export default SearchBar;